import { ISimpleTableRow } from "@asup/simple-table";
import { eReleaseStatus } from "functions/api/enums";

/**
 * Filters out retired or decommissioned TLF templates.
 *
 * @param row - Table row containing release status
 */
export const filterTemplates = (row: ISimpleTableRow) =>
  [eReleaseStatus.Retired, eReleaseStatus.Decommissioned].includes(
    row.releaseStatus as eReleaseStatus,
  );
